import { render } from "./CardHeader.vue?vue&type=template&id=27ab760e"
import script from "./CardHeader.vue?vue&type=script&lang=js"
export * from "./CardHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__